/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react'
import styles from './styles'
import { CrossIcon } from '../icons'
import cookies from '../../utils/cookies'
import cookieOpts from './alertCookieOpts'
import { STV_COOKIES } from '../../constants'

const AlertBanner = (data) => {
  const { STV_ALERT_COOKIE } = STV_COOKIES
  const [showHideBanner, setShowHideBanner] = useState('')
  const alertHeadRef = useRef(null)
  const [alertData, setAlertData] = useState([])
  const [alertDisplaying, setAlertDisplaying] = useState({})
  const [dataPopulated, setDataPopulated] = useState(false)

  let strapiAlerts = []
  let cookieAlerts = []
  let alreadySeenAlerts = []
  let filteredAlerts

  useEffect(() => {
    window.addEventListener('scroll', makeSticky)
  }, [])

  useEffect(() => {
    if (data.data[0]?.id) {
      strapiAlerts = data?.data
      cookieAlerts = cookies.get(STV_ALERT_COOKIE, cookieOpts())
      alreadySeenAlerts = cookieAlerts || []
      filteredAlerts = strapiAlerts?.filter(alert => !alreadySeenAlerts?.includes(alert.id))
      setAlertData(filteredAlerts)
      setAlertDisplaying(filteredAlerts[0])
      setDataPopulated(true)
    }
  }, [data])

  const handleClick = () => {
    setShowHideBanner('hidden')
    document.querySelector('.AlertBanner').addEventListener('animationend', transitionDone)
  }

  const transitionDone = () => {
    const opts = cookieOpts()
    const idList = cookies.get(STV_ALERT_COOKIE, opts) ? JSON.parse(cookies.get(STV_ALERT_COOKIE, opts)) : []
    if (!idList.includes(alertDisplaying.id)) {
      const newList = [...idList, alertDisplaying.id]
      cookies.remove(STV_ALERT_COOKIE, { path: '' })
      cookies.set(STV_ALERT_COOKIE, newList, opts)
      removeUsedAlert(newList)
    }
  }

  const removeUsedAlert = (usedAlerts) => {
    strapiAlerts = alertData
    filteredAlerts = alertData?.filter(alert => !usedAlerts?.includes(alert.id))
    setAlertData(filteredAlerts)
    setAlertDisplaying(filteredAlerts[0])

    setShowHideBanner('')
  }

  const makeSticky = () => {
    const { pageYOffset } = window

    if (pageYOffset > 80) {
      alertHeadRef?.current?.classList.add('stuck')
    } else if (pageYOffset <= 80) {
      alertHeadRef?.current?.classList.remove('stuck')
    }
  }

  if (!dataPopulated) return null

  if (!alertDisplaying) return null

  return (
    <div className={`AlertBanner ${alertDisplaying?.attributes?.AlertColour} ${showHideBanner}`} ref={alertHeadRef}>
      <div className="banner-icon">
        <img src={alertDisplaying?.attributes?.Icon?.data?.attributes?.url} className="player-vip-landing-logo" alt={alertDisplaying?.attributes?.Icon?.data?.attributes?.alternativeText} />
      </div>
      <div className="banner-content">
        <h3 className="banner-title">{alertDisplaying?.attributes?.Title}</h3>
        {alertDisplaying?.attributes?.Message && (
          <div
            className="Article"
            dangerouslySetInnerHTML={{ __html: alertDisplaying?.attributes?.Message }} // eslint-disable-line
          />
        )}
      </div>
      <div className="close-icon-wrapper">
        <button
          className="close-icon button-reset"
          onClick={handleClick}
          type="button"
          id="close-button"
        >
          <CrossIcon width={16} height={16} color="#FFFFFF" />
        </button>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

export default AlertBanner
